// extracted by mini-css-extract-plugin
export default {"field":"CurrencySmallIcon_field__KK2T3","currencyIcon":"CurrencySmallIcon_currencyIcon__f1Vpv"};